import { gql } from '@apollo/client';

const GET_CLAIM_VIDEOS_LIST_PAGED = gql`
query claimVideosPaged ($regionId: Int!, $claimIndx: Int!, $currentPage: Int, $itemsPerPage: Int) {
  claimVideosPaged(regionId: $regionId, claimIndx: $claimIndx, currentPage: $currentPage, itemsPerPage: $itemsPerPage)
  {
    items {
      filePath
      thumbnailFileName
      areaOfLoss
      phase
      description
      fileExtension
      uploadedDate
      fileMetaData
      fileSize
      fileName
      sentToXactEm
      sentToXactRe
      isCustomerVisible
      fileTypeCd
      ctfileId
      roomId
      includedInIsi
      xactimate
      isSymbilityDoc
    }
    currentPage
    pageSize
    totalItems
  }
}`;

export default GET_CLAIM_VIDEOS_LIST_PAGED;